var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EditorContent,_vm._g(_vm._b({attrs:{"editor":_setup.props.instance}},'EditorContent',_setup.attrs,false),_setup.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }